import { render, staticRenderFns } from "./OIDC.vue?vue&type=template&id=3d70fc7b"
import script from "./OIDC.vue?vue&type=script&lang=js"
export * from "./OIDC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports